<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <div>
        <form novalidate class="md-layout md-alignment-top-center" @submit.prevent="validateIntegrator">
          <div class="md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100">

            <field fieldName="name" ref="name" :validations="{required: true}" :fieldValue=form.name fieldLabel="Name"
              fieldId="name" :sending="sending" @setfield="setFormField($event)" />

            <multiple-fields fieldName="trustedDomains" ref="trustedDomains" :validations="{required: true}"
              :fieldValue=form.trustedDomains fieldLabel="Trusted Domains" fieldId="trustedDomains" :sending="sending"
              @setfield="setFormField($event)"/>
            <md-progress-bar md-mode="indeterminate" v-if="sending" />
            <md-button type="submit" class="md-raised md-primary" :disabled="sending">Create</md-button>
          </div>
        </form>
      </div>
    </main>
  </navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Field from '@/components/elements/field'
import MultipleFields from '@/components/elements/multiplefields'
import NotificationService from '@/services/notificationService'

export default {
  name: 'create-integrator',
  data: () => ({
    form: {
      name: null,
      trustedDomains: ['']
    },
    title: 'Create Integrator',
    abstract: 'Create a new integrator',
    sending: false
  }),
  components: {
    NavigationLayout,
    Field,
    MultipleFields
  },
  methods: {
    async validateIntegrator () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (canSave) {
        this.sending = true
        this.createIntegrator()
        this.sending = false
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    },
    clearForm () {
      this.form.name = null
      this.form.trustedDomains = ['']
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].clearField) {
          this.$refs[property].clearField()
        }
      }
    },
    async createIntegrator () {
      await NotificationService.manageNotification(this, await RepositoryService.createIntegrator(this.form.name, this.form.trustedDomains),
        (data) => {
          this.$refs.navigationlayout.setNotification(`The integration with id ${data} was saved with success!`)
          this.clearForm()
        })
    }
  }
}

</script>
